import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { OwnershipType } from 'src/app/core/enums/ownership-type.enum';

export class CollectionOwnerCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {
    if (_collection.ownerShipType === OwnershipType.COMMUNITY) {
        return 0;
    } 
    return _collection.owner?.displayName.toLowerCase().includes(_query) ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.OWNER,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.OWNER,
      matchScore: this.getMatchScore(_collection, _query),
    }
  }
}